// hjjtw beta
const url = {
  apiHost: 'https://api.goer.live/',
  socket: 'wss://cnpd0m5sw4.execute-api.ap-northeast-2.amazonaws.com/beta/',
  unAuthSocket:
    'wss://5nfqn71n44.execute-api.ap-northeast-2.amazonaws.com/beta',
  cdn: 'https://cdn.goer.live/',
  backstage:
    'http://beta.backstage.hjjtw.weiqi.study.s3-website.ap-northeast-2.amazonaws.com/',
  homepage:
    'http://beta.hjjtw.weiqi.study.s3-website.ap-northeast-2.amazonaws.com/',
};

export default url;
